export default {
	namespaced: true,
	state: {
		isValidDescription: false,

	},

	actions: {
		validateDescription(context)
		{
			let valid = false;

			let payload = context.rootGetters['routes/editableDescription'];
			let path = undefined;
			if(payload.files.length == 1)
			{
				path = payload.files[0].path
			}

			
			
			context.dispatch('validateDescriptionText', payload.descriptionText)
			.then((validDescriptionText) => {
				valid = validDescriptionText;

				if(payload.type === 'YoutubeVideo' && valid === true)
				{
					context.dispatch('checkpointsValidator/validateYoutubeVideoTask', path, {root: true})
					.then((validYoutubeVideoPath) => {
						//console.log("validYoutubeVideoPath", validYoutubeVideoPath)
						context.commit('setIsValidDescription', validYoutubeVideoPath.valid)
					})
				} else if(payload.type === 'Image' && valid === true)
				{
					context.dispatch('validateDescriptionImage', payload)
					.then((validDescriptionImage) => {
						context.commit('setIsValidDescription', validDescriptionImage)
					})
				} else {
					context.commit('setIsValidDescription', valid)
				}
			})


			 
		},

		validateDescriptionText(context, payload)
		{
			let valid = false;

			if(payload.trim() !== '')
			{
				valid = true;
			}

			return Promise.resolve(valid)
		},

		validateDescriptionImage(context, payload)
		{
			let valid = false


			
			if(payload.files.length == 1 && payload.files[0].type === 'Image')
			{
				valid = true;
			}
			return Promise.resolve(valid)
		}
	},

	mutations: {

		setIsValidDescription(state, payload)
		{
			state.isValidDescription = payload
		}
	},

	getters: {
		isValidDescription(state)
		{
			return state.isValidDescription;
		}
	}
}